import Joi from 'joi';
import PropTypes from 'prop-types';
import Form from '../../common/form';

import * as utils from '../../../utils/utilities';

class HelideckDropSketchForm extends Form {
	state = {
		data: { images: [] },
		errors: {},
		loading: false,
		progress: 0,
		places: [],
	};

	static propTypes = {
		onProceed: PropTypes.func,
	};

	schema = {
		images: Joi.array().min(1).required().label('Inspection Sketch'),
	};

	doSubmit = (): void => {
		const props: any = this.props;
		props.onProceed(this.state.data.images);
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit} className="p-3">
				{this.renderFileInput({
					max: 1,
					multiple: false,
					name: 'images',
					accept: 'image/*,application/pdf',
					label: 'Inspection Sketch',
					sublabel: 'Upload Inspection Sketch Image',
					types: utils.getFileUploadTypes(),
				})}

				<div className="d-flex justify-content-end">
					{this.renderButton('Proceed')}
				</div>
			</form>
		);
	}
}

export default HelideckDropSketchForm;
